import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { baromoneyTransferSettingApi } from '@/api/baromoney-transfer-setting';
import BaromoneyTransferSettingVM from '@/view-model/baromoney-transfer-setting/BaromoneyTransferSettingVM';
import PaginationOutput from '@/helpers/PaginationOutput';
export const baromoneyTransferSettingService = {
    async getItemList(param = {
        pageNumber: 1,
        pageSize: '20',
        status: '',
        type: '',
        fromDate: '',
        toDate: '',
        searchType: '',
        searchText: '',
    }) {
        const params = new QueryParameterBuilder()
            .addPage(param.pageNumber)
            .addSize(param.pageSize)
            .add('status', param.status)
            .add('type', param.type)
            .add('fromDate', param.fromDate)
            .add('toDate', param.toDate);
        if (param.searchText) {
            params
                .add('searchType', param.searchType)
                .add('searchText', param.searchText);
        }
        const response = await baromoneyTransferSettingApi.getItemList(params.build());
        const entityResult = PaginationOutput.adaptorFactory(response, BaromoneyTransferSettingVM);
        return {
            list: entityResult.list,
            paginationData: entityResult.paginationData,
        };
    },
    /**
     * 단건 조회
     */
    async getItem(id) {
        const response = await baromoneyTransferSettingApi.getItem(id);
        return new BaromoneyTransferSettingVM(response.data.data);
    },
};
